import { isNetworkError } from "./isNetworkError.js";
const STORAGE_KEY = "reload-for-error-count";
const MAX_RELOAD_COUNT = 2;
export function shouldReloadForError(error) {
  if (/upchat/i.test(navigator.userAgent) && isNetworkError(error)) {
    var _sessionStorage$getIt;
    const count = +((_sessionStorage$getIt = sessionStorage.getItem(STORAGE_KEY)) !== null && _sessionStorage$getIt !== void 0 ? _sessionStorage$getIt : 0);
    if (count < MAX_RELOAD_COUNT) {
      sessionStorage.setItem(STORAGE_KEY, String(count + 1));
      return true;
    }
    resetReloadForError();
  }
  return false;
}
export function resetReloadForError() {
  sessionStorage.removeItem(STORAGE_KEY);
}
//# sourceMappingURL=shouldReloadForError.js.map